module.exports = __webpack_public_path__ + "static/media/PaymentCouponScreen.071e6c49.png";